<script>
  import { onMount, createEventDispatcher } from "svelte";
  let dispatch = createEventDispatcher();
  import { UserName } from "./store.js";

  onMount(async function() {
    if (!$UserName)
      dispatch("pageChange", "/register/start");
  });
</script>

<form action="" class="box">
  <h1 class="title is-4">Security Questions Configured</h1>
  <p>
    Your username is
    <strong>{$UserName}</strong>
  </p>
  <div style="text-align: right; margin-top: 15px;">
    <a href="/signin/{$UserName}/" class="button is-purple">Login to eAdmissions</a>
  </div>
</form>
